module.exports = __webpack_public_path__ + "static/assets/b8d9a709f89931cdd91d3243f1f0c3ff.png";